export default "__VITE_ASSET__b946960a__"